// Gate partagé entre structureSync (diffusion collab) et undoCapture (pile undo
// locale) : décide si l'état courant représente une édition légitime de
// l'utilisateur dans l'éditeur, plutôt qu'un vidage/repeuplement du store au
// (re)chargement ou un retour à la liste.
//
// ⚠️ Garde anti-perte de données : `setCurrentDocument` vide toutes les
// collections au (re)chargement. Sans ce gate, ce vidage produirait un diff
// plein de deletes — diffusé/persisté comme une suppression de tout le content,
// ou empilé comme une entrée undo aberrante. Cf. docs/collab/07-anti-data-loss.
//
// `collabConnected` n'est PAS inclus ici : structureSync l'exige en plus (rien
// ne se diffuse hors collab), mais l'undo capture même en solo.

export const docIdOf = (state) =>
  state.currentDocument?.type === 'template'
    ? state.currentDocument?.id
    : state.currentProposal?.id;

// Vrai quand on édite vraiment : pas sur la liste des documents, pas en
// (re)chargement, et l'identité du document n'a pas changé depuis la baseline.
export const isStableEditState = (state, baselineDocId) =>
  !state.proposalList &&
  !state.isDocumentLoading &&
  docIdOf(state) === baselineDocId;
